// extracted by mini-css-extract-plugin
module.exports = {"icon":"HamburgerIcon__icon___hNivY","dc":"HamburgerIcon__dc___2W3bY"};